import { useModal, ModalSize } from "@shared/context/ModalContext";
import { useTranslations } from "@shared/context/useTranslations";
import { PickupLocationsModalContent } from "@shared/components/Molecules/PickupLocationsModal/PickupLocationsModal.component";
import { PickupLocation } from "@shared/types/CategoryTypes.interface";

export const usePickupLocationsModal = () => {
    const { getTranslation } = useTranslations();
    const { showModal, closeModal } = useModal();

    const handlePickupClick = (pickupLocations: PickupLocation[]) => {
        showModal(<PickupLocationsModalContent pickupLocations={pickupLocations} />, {
            size: ModalSize.SM,
            shouldCloseOnOverlayClick: true,
            shouldCloseOnEsc: true,
            title: getTranslation("general.pickupLocation.modal.title"),
            description: getTranslation("general.pickupLocation.modal.description"),
            cancelButton: {
                label: getTranslation("general.close"),
                onClick: closeModal,
            },
        });
    };

    return { handlePickupClick };
};
